import { api } from '../api';

const resource = '/inventory';

export const getInventory = async () => {
  return api.get(resource);
};

export const addInventory = async (item) => {
  return api.post(resource, item);
};

export const updateInventory = async (id, item) => {
  return api.put(`${resource}/${id}`, item);
};
